// src/pages/Project.js
import React, { useEffect, useState } from "react";
import "./Profile.css";

const Profile = () => {
  const [user, setUser] = useState(null);
  const [goals, setGoals] = useState({
    dailyGoal: "Run 5km",
    weeklyGoal: "Workout 4 times",
  });
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("currentUser"));
    if (userData) {
      setUser(userData);
    }
  }, []);

  const handleChange = (e) => {
    setGoals({ ...goals, [e.target.name]: e.target.value });
  };

  const toggleEdit = () => {
    setEditing(!editing);
  };

  if (!user) {
    return <div className="profile-container">Loading profile...</div>;
  }

  return (
    <div className="profile-container">
      <div className="profile-card">
        <img
          src={`https://ui-avatars.com/api/?name=${user.email}&background=0D8ABC&color=fff`}
          alt="Profile"
          className="profile-avatar"
        />
        <h2>{user.email}</h2>
        <p>Fitness Enthusiast</p>

        <div className="summary-cards">
          <div className="card">
            <h3>Workouts</h3>
            <p>25</p>
          </div>
          <div className="card">
            <h3>Calories Burned</h3>
            <p>5,300 kcal</p>
          </div>
          <div className="card">
            <h3>Goals Achieved</h3>
            <p>12</p>
          </div>
        </div>

        <div className="goal-section">
          <h3>My Goals</h3>
          {editing ? (
            <>
              <input
                type="text"
                name="dailyGoal"
                value={goals.dailyGoal}
                onChange={handleChange}
              />
              <input
                type="text"
                name="weeklyGoal"
                value={goals.weeklyGoal}
                onChange={handleChange}
              />
              <button onClick={toggleEdit}>Save</button>
            </>
          ) : (
            <>
              <p><strong>Daily Goal:</strong> {goals.dailyGoal}</p>
              <p><strong>Weekly Goal:</strong> {goals.weeklyGoal}</p>
              <button onClick={toggleEdit}>Edit Goals</button>
            </>
          )}
        </div>

        <div className="activity-section">
          <h3>Recent Activity</h3>
          <ul>
            <li>🏋️‍♀️ Weight Training - 45 mins</li>
            <li>🏃‍♂️ Running - 5km</li>
            <li>🚴‍♀️ Cycling - 30 mins</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Profile;
